/**
 * nt-utils.js
 * Small dependency-free helpers reused by other nt-*.js modules.
 * Exposed on window.ntUtils so every section script can share one copy.
 */
(function () {
  'use strict';

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function getQueryParam(name) {
    return new URLSearchParams(window.location.search).get(name);
  }

  function setSession(key, value) {
    try { sessionStorage.setItem(key, value); } catch (e) { /* storage unavailable */ }
  }

  function getSession(key) {
    try { return sessionStorage.getItem(key); } catch (e) { return null; }
  }

  function trapFocus(container) {
    var focusable = container.querySelectorAll('a[href], button:not([disabled]), input, textarea, select');
    if (!focusable.length) return function () { };
    var first = focusable[0], last = focusable[focusable.length - 1];
    function handler(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', handler);
    return function () { container.removeEventListener('keydown', handler); };
  }

  window.ntUtils = {
    debounce: debounce,
    getQueryParam: getQueryParam,
    setSession: setSession,
    getSession: getSession,
    trapFocus: trapFocus
  };
})();
